import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "./App";
import AppContextProvider from "./Contexts/AppContextProvider";
import { remap } from "./remaps";
import "./locale/index";

const backupContext = document.getElementById(
	"nav-global-lang",
) as HTMLAnchorElement | null;

if (backupContext) {
	const isWelsh = window.location.href.includes("lang=cy");
	backupContext.href = isWelsh ? "?lang=en" : "?lang=cy";
	backupContext.innerText = isWelsh ? "English" : "Cymraeg";
}

if (import.meta.env.PROD) {
	import("./sentry").then((mod) => mod.initSentry());
}

remap();

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			gcTime: 1000 * 60 * 60 * 24, // 24 hours
		},
	},
});
const root = document.getElementById("root");
if (!root) {
	throw new Error("Root element not found");
}

createRoot(root).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<AppContextProvider>
				<App />
			</AppContextProvider>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	</StrictMode>,
);
